export default __webpack_public_path__ + "static/media/promo_coda__b4z92qy59piq_small_2x.05dd64e1.jpg";